/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    footer: {
        padding: '0px',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        fontSize: '10px',
        fontWeight: '400',
        color: tokens.colorNeutralForeground3,
        alignItems: 'center'
    },
    feedbackRow: {
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        alignItems: 'center'
    }
});
